import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Contact: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="contact" className="contact">
      <h2>{t('contact.title')}</h2>
      <div className="contact-info">
        <p>{t('contact.email')} info@nutrifitconsulting.be</p>
        <p>{t('contact.phone')} +32 XXX XXX XXX</p>
        <p>{t('contact.address')} Your Address Here</p>
      </div>
      <form className="contact-form">
        <input type="text" placeholder={t('contact.form.name')} />
        <input type="email" placeholder={t('contact.form.email')} />
        <textarea placeholder={t('contact.form.message')}></textarea>
        <button type="submit">{t('contact.form.submit')}</button>
      </form>
    </section>
  );
};

export default Contact; 